import { combineReducers } from 'redux';

import enforcementDisruptedReasons from '../enforcementDisruptedReasons';
import processingValues from './processingValues';
import relaunchEnforcement from './relaunchEnforcement';
import values from './values';

const links = {
  processingValues,
  enforcementDisruptedReasons,
  relaunchEnforcement,
  values,
};

export default combineReducers(links);
